import { Badges } from '@event/components/display/tabs/Badges';
import { useEventDashboardContext } from '@event/contexts/EventContext';
import Box from '@mui/material/Box/Box';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import { lazy, Suspense, useCallback } from 'react';
const AnalyticsOverview = lazy(() => import('@event/components/display/tabs/AnalyticsOverview/EventAnalyticsOverview'));
const Cohost = lazy(() => import('@event/components/display/tabs/Cohost/Cohost'));
const Details = lazy(() => import('@event/components/display/tabs/Details/Details'));
const RegistrationDetails = lazy(
    () => import('@event/components/display/tabs/RegistrationDetails/RegistrationDetails')
);
const Audience = lazy(() => import('@event/components/display/tabs/Audience/Audience'));

type Props = {
    isCohostPermissionsLoading: boolean;
};

const EventOverview = ({ isCohostPermissionsLoading }: Props) => {
    const {
        accordionsState: [accordionsState, setAccordionsState],
    } = useEventDashboardContext();

    const handleAccordionChange = useCallback(
        (panel: string) => (_event: React.SyntheticEvent, expanded: boolean) => {
            setAccordionsState((prev) => ({
                ...prev,
                [panel]: expanded,
            }));
        },
        [setAccordionsState]
    );

    return (
        <div>
            <Suspense
                fallback={
                    <Box minHeight={800} position="relative">
                        <CircularProgress className="absolute-center" />
                    </Box>
                }
            >
                <AnalyticsOverview />
                <Cohost
                    isLoading={isCohostPermissionsLoading}
                    expanded={accordionsState.cohost}
                    onChange={handleAccordionChange('cohost')}
                />
                <Details expanded={accordionsState.details} onChange={handleAccordionChange('details')} />
                <RegistrationDetails
                    expanded={accordionsState.registration_details}
                    onChange={handleAccordionChange('registration_details')}
                />
                <Badges expanded={accordionsState.badges} onChange={handleAccordionChange('badges')} />
                <Audience expanded={accordionsState.audience} onChange={handleAccordionChange('audience')} />
            </Suspense>
        </div>
    );
};

export { EventOverview };
